import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';


export enum HistoryTabs {
    SaleHistory = 1,
    PriceHistory = 2,
    LeasingHistory = 3
}

@Component({
    selector: 'app-property-history',
  templateUrl: './property-history.component.html',
  styleUrls: ['./property-history.component.css']
})

export class PropertyHistoryComponent implements OnInit {
  @Input() propertyId: number;
  @Input() IsDataEntryPrperty: boolean;
    @Input() IsPDeleted: boolean = false;
    @Input() YearBuilt: number;
    @Input() property = {} as any;
    historyTabs = HistoryTabs;
    transactionTypeId = 6500;
    showPage = true;
    activeTab = this.historyTabs.SaleHistory;
    showAddHistory: boolean = false;
    user: any;
    disableAddEditHistoryButton = false as boolean;
    constructor(public authService: AuthenticationService) { }

    ngOnInit() {
        
        this.user = this.authService.user != null ? this.authService.user : '';
        if (this.user != '')
        {
            this.showAddHistory = true;
        }
    }

    onTabClick(tab, typeId: number) {
        this.showPage = false;
        this.activeTab = tab
        this.transactionTypeId = typeId;
        this.showPage = true;
    }
    openHistoryAdd() {
        this.disableAddEditHistoryButton = true;
        if (this.activeTab == this.historyTabs.SaleHistory) {
            $('#hdnSalesHistory').click();
        }
        else {
            $('#hdnLeasingHistory').click();
        }

    }

    disableButton(evevt) {
        this.disableAddEditHistoryButton = false;
    }
}
